import React, { useState } from 'react';
import { useContext } from 'react';
import { UserContext } from './UserContext'; // adjust path if needed
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Container, Typography } from '@mui/material';
import axios from 'axios';

async function hashPassword(password) {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer)).map(b => b.toString(16).padStart(2, '0')).join('');
}

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const navigate = useNavigate();

  const { setUser } = useContext(UserContext);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        'https://v206drsmij.execute-api.us-east-2.amazonaws.com/readUser',
        { email: formData.email }
      );

      const user = response.data.user;
      const hashedInput = await hashPassword(formData.password);

      if (hashedInput === user.passwordHash.S) {
        // ✅ Save user info globally
        setUser({
          email: user.email?.S,
          firstName: user.firstName?.S,
          lastName: user.lastName?.S,
          // add more fields as needed
        });

        navigate('/dashboard');
      } else {
        alert('Invalid email or password');
      }
    } catch (err) {
      alert('Login failed: ' + err.message);
    }
  };


  return (
    <Container maxWidth="sm" style={{ marginTop: '4rem' }}>
      <Typography variant="h4" gutterBottom>
        Sign In
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <TextField
          label="Password"
          name="password"
          type="password"
          value={formData.password}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <Button
          variant="contained"
          color="primary"
          type="submit"
          fullWidth
          style={{ marginTop: '1rem' }}
        >
          Sign In
        </Button>
      </form>
    </Container>
  );
};

export default Login;